import { DEFAULT_RICOS_COMPONENT_DATA } from "./defaults.js";
import { POLL_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers-lazy.js";
const pluginPoll = (config) => {
  return {
    config: { ...DEFAULT_RICOS_COMPONENT_DATA.containerData, ...config },
    type: POLL_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginPoll
};
//# sourceMappingURL=viewer-lazy.js.map
